export default {
  // Tiêu đề trang
  'manualTag.title': 'Quản lý nhãn thủ công',
  
  // Trường biểu mẫu
  'manualTag.form.tagName': 'Tên nhãn',
  'manualTag.form.tagNamePlaceholder': 'Vui lòng nhập tên nhãn',
  'manualTag.form.tagNameRequired': 'Tên nhãn không được để trống',
  'manualTag.form.tagNameMaxLength': 'Tên nhãn không quá 50 ký tự',
  'manualTag.form.tagDescription': 'Mô tả nhãn',
  'manualTag.form.tagDescriptionPlaceholder': 'Vui lòng nhập mô tả nhãn (tùy chọn, chỉ hiển thị trong backend)',
  'manualTag.form.tagDescriptionMaxLength': 'Mô tả nhãn không quá 255 ký tự',
  'manualTag.form.currencyScope': 'Loại tiền áp dụng',
  'manualTag.form.currencyPlaceholder': 'Chọn loại tiền áp dụng',
  'manualTag.form.currencyFilterPlaceholder': 'Tất cả loại tiền',
  'manualTag.form.currencyRequired': 'Chọn ít nhất một loại tiền',
  
  // Trường bảng
  'manualTag.table.tagName': 'Tên nhãn',
  'manualTag.table.currencyScope': 'Loại tiền áp dụng',
  'manualTag.table.tagDescription': 'Mô tả',
  'manualTag.table.hitCount': 'Số lượng người dùng',
  'manualTag.table.createTime': 'Thời gian tạo',
  'manualTag.table.action': 'Hành động',
  
  // Nút hành động
  'manualTag.action.create': 'Tạo nhãn',
  'manualTag.action.editTags': 'Chỉnh sửa nhãn',
  
  // Tiêu đề hộp thoại
  'manualTag.modal.createTitle': 'Tạo nhãn',
  'manualTag.modal.editTitle': 'Chỉnh sửa nhãn',
  'manualTag.modal.editMemberTagTitle': 'Chỉnh sửa nhãn thành viên',
  'manualTag.modal.editHint': 'Nhấp vào hộp kiểm để thêm hoặc xóa nhãn cho thành viên',
  
  // Tin nhắn
  'manualTag.message.createSuccess': 'Tạo nhãn thành công',
  'manualTag.message.createFailed': 'Tạo nhãn thất bại',
  'manualTag.message.updateSuccess': 'Cập nhật thành công',
  'manualTag.message.updateFailed': 'Cập nhật thất bại',
  'manualTag.message.deleteSuccess': 'Xóa nhãn thành công',
  'manualTag.message.deleteFailed': 'Xóa nhãn thất bại',
  'manualTag.message.deleteConfirm': 'Bạn có chắc chắn muốn xóa nhãn này?',
  'manualTag.message.deleteWarning': 'Sau khi xóa, tất cả thành viên có nhãn này sẽ bị xóa nhãn',
  
  // Khác
  'manualTag.noTags': 'Không có nhãn',
  'manualTag.noTagsAvailable': 'Không có nhãn khả dụng, vui lòng tạo nhãn trong quản lý nhãn trước',
};
